import React from "react";
import type { KgUserIconProps } from "./KgUserIcon.types";

/** Single-user icon for data story inspector Owner row (Figma `user-2`). */
export const KgUserIcon: React.FC<KgUserIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M10.6667 4.66667C10.6667 6.13943 9.47276 7.33333 8 7.33333C6.52724 7.33333 5.33333 6.13943 5.33333 4.66667C5.33333 3.19391 6.52724 2 8 2C9.47276 2 10.6667 3.19391 10.6667 4.66667Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66675 14C2.66675 11.0545 5.05456 8.66667 8.00008 8.66667C10.9456 8.66667 13.3334 11.0545 13.3334 14"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgUserIcon;
